import styled from 'styled-components';
import { boldFont, screenSize } from '@app/styles';
type props = {
  size?: string;
  customStyles?: string;
  isCenter?: boolean;
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
`;

export const Backdrop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width:95%;
  min-height:300px;
  max-height: 90%;
  overflow-x: hidden;
  overflow-y:auto;
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 7px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.15), 0 1px 12px rgba(0, 0, 0, 0.25);
  ${({ size }: props) => {
    if (size === 'small') {
      return `min-height:80px;
      min-width:95%;`;
    } else if (size === 'medium') {
      return `min-height:150px;
      min-width:95%;`;
    }
  }}
  @media (${screenSize.tablet}) {
  min-height: 420px;
  max-height: 90%;
  min-width: 640px;
  max-width: 90%;
  @media (${screenSize.desktop}){
    min-width:800px;
    ${({ size }: props) => {
      if (size === 'small') {
        return `min-height:100px;
        min-width:640px;`;
      }
      if (size === 'medium') {
        return `
        min-height:150px;
        min-width:640px;
       `;
      }
    }}
  }

  ${({ size }: props) => {
    if (size === 'small') {
      return `min-height:100px;
      min-width:640px;`;
    }
    if (size === 'medium') {
      return `
      min-height:150px;
      min-width:640px;
     `;
    }
  }}
  }
  
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0px 15px;
  margin: 10px 0px;
  cursor: pointer;
  justify-content: space-between;
  ${({ isCenter }: props) => {
    if (isCenter) {
      return `justify-content:center;`;
    }
  }}
`;
export const Seperator = styled.div`
  background-color: #e4e6eb;
  border: 1px solid #e4e6eb;
  margin: 0px 0px 12px 0px;
`;
export const Title = styled.div`
  font-size: 1.3rem;
  color: black;
  // font-family: Noto Serif;
  font-style: normal;
  ${boldFont}
  @media (${screenSize.tablet}) {
    margin-left: 8px;
  }
  ${({ customStyles }: props) => {
    if (customStyles) {
      return `${customStyles}
      @media (${screenSize.tablet}) {
        margin-left: 0px;
      }`;
    }
  }}
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 12px;
  cursor: pointer;
`;

export const BackIcon = styled.div`
  position: absolute;
  left: 12px;
  cursor: pointer;
`;

export const Body = styled.div`
  flex: 1;
  background-color: #dce0e8;
  padding: 15px;
`;
